import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(4),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(6.875),
  },
  mainButton: {
    marginLeft: theme.spacing(2),
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    rowGap: theme.spacing(1),
  },
  label: {
    ...theme.typography.label,
  },
  comboPostalCode: {
    '& .input-small': {
      width: '140px',
    },
  },
}))

export default useStyles
